import { AuthModel, AuthRequestModel, UserModel } from "@tsin-core/models/auth.model";

const ACTION_SCOPE = '[Auth]';

/**
 * Set auth state directly from an external token exchange response (e.g. Cognito SSO).
 * Bypasses the learning-backend /user/me call so the JWT secret mismatch is irrelevant.
 *
 * Définit l'état d'authentification directement depuis une réponse d'échange de jeton
 * externe (ex. SSO Cognito). Contourne l'appel /user/me du backend d'apprentissage.
 */
export class SetAuthAction {
  static readonly type = `${ACTION_SCOPE} Set Auth`;
  constructor(public payload: {
    token: string;
    refreshToken: string | null;
    user: Partial<UserModel>;
  }) {}
}

export class AuthenticateAction {
  static readonly type = `${ACTION_SCOPE} Login`;
  constructor(public payload: AuthRequestModel) { }
}

export class ValidateTokenAction {
  static readonly type = `${ACTION_SCOPE} Validate Token`;
  constructor(public payload: { token: string; refreshToken: string }) { }
}

export class RefreshTokenAction {
  static readonly type = `${ACTION_SCOPE} Refresh Token`;
  constructor(public payload: { refreshToken: string }) { }
}
export class ActivateGuestAction {
  static readonly type = `${ACTION_SCOPE} Activate Guest Code`;
  constructor(public payload: { code: string }) { }
}

export class LogoutAction {
  static readonly type = `${ACTION_SCOPE} Logout`;
}

export class SetLoading {
  static readonly type = `${ACTION_SCOPE} Set Loading`;
  constructor(public loading: boolean) { }
}

export class SetError {
  static readonly type = `${ACTION_SCOPE} Set Error`;
  constructor(public error: string | null) { }
}
